var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outlined":"","color":"black","label":_vm.label,"type":"number","value":_vm.value},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }